<svelte:options accessors={true} />

<script>
	import 'whatwg-fetch';

	import { scaleLinear } from 'd3-scale';
	import { line } from 'd3-shape';
	import XAxis from './distDotPlotComponents/XAxis.svelte';
	import Annotation from './distDotPlotComponents/Annotation.svelte';
    import ViolinDotPlot from './distDotPlotComponents/ViolinDotPlot.svelte';

	export let data;
	export let width = 640;
	export let distributionData;
	export let area;

	console.log(area)
	console.log(data)

    //split out data
    let indicatorCircleData = [];

    Object.keys(data).forEach(function(key) {

        Object.keys(data[key]).forEach(function(subKey) {

            indicatorCircleData.push({label: subKey, value2019: data[key][subKey]["2019"], value: data[key][subKey]["2020"] })
        })
    })

    let circleDataLower = indicatorCircleData.filter(function(e,i) {return e.value <= 90}).sort((a,b) => a.value - b.value); 
    let circleDataHigher = indicatorCircleData.filter(function(e,i) {return e.value >= 110}).sort((a,b) => b.value - a.value); 

	let padding = {top: 160, left: 5, right: 5, bottom: (width > 560 ? 20 : 120)}

    let height = width > 560 ? padding["top"]+40*Math.max(circleDataLower.length, circleDataHigher.length)+padding["bottom"] : padding["top"]+60*Math.max(circleDataLower.length + circleDataHigher.length)+padding["bottom"]

	let maxValue = Math.max(...indicatorCircleData.map(el => {return Math.max(el.value, el.value2019)}));

	let x = width > 560 ? scaleLinear().domain([10, Math.max(maxValue,125)+10]).range([0,width/2-padding["left"]-padding["right"]]) : scaleLinear().domain([10, Math.max(maxValue,125)+10]).range([0,width-padding["left"]-padding["right"]])

	let seriesPadding = 0;

	let y  = width > 560 ? scaleLinear().domain([0,Math.max(circleDataHigher.length, circleDataLower.length)]).range([0, height-padding["top"]-padding["bottom"]-seriesPadding*2]): scaleLinear().domain([0,Math.max(circleDataHigher.length + circleDataLower.length)]).range([0, height-padding["top"]-padding["bottom"]-60-seriesPadding*2])

	let seriesParametersArray = [
                                {key: "value2019", yAdj: -5, color: "#003C57"}, 
                                {key: "value", yAdj: 5, color: "#00A3A6"}
                            ];

	let gridlinesParametersArray = [
	//{value: 80, opacity: 0.10},
	{value: 90, opacity: 0.20},
	{value: 100, opacity: 0.75},
	{value: 110, opacity: 0.20},
	//{value: 120, opacity: 0.10},
	]

	let yDist = scaleLinear()
		.domain([0,50])
		.range([0,20]);
	
	let pathCalc = line()
    	.x((d) => { return x(d["midpoint"]); })
    	.y((d) => { return -yDist(d["yValue"]); });

	let pathCalcInv = line()
    	.x((d) => { return x(d["midpoint"]); })
    	.y((d) => { return yDist(d["yValue"]); });


	let xKey = scaleLinear()
		.domain([10, 125])
		.range([0, width/2]);

	let pathCalcXKey = line()
    	.x((d) => { return xKey(d["midpoint"]); })
    	.y((d) => { return -yDist(d["yValue"]); });

	let pathCalcInvXKey = line()
    	.x((d) => { return xKey(d["midpoint"]); })
    	.y((d) => { return yDist(d["yValue"]); });

	let distributionText = "Distribution of local authority values in 2020";
	if (width <= 420) {distributionText = ["Distribution of local", "authority values in 2020"] };



	let annotationsArray = [
{position:[xKey(100), -21], path:"M0 0 l0 -5 l-40 0", textAnchor:"end", fontSize: 14, opacity:0.75, text:"Health in England in 2015", stroke:"#333", x:-43, y:-2},
{position:[xKey(95), 15], path:"M0 0 l0 10 l-20 0", textAnchor:"end", fontSize: 14, opacity:1, text: distributionText, stroke:"#919090", x:-23, y:13},
{position:[xKey(110), 0], path:"M0 0 l0 -10 l10 0", textAnchor:"start", fontSize: 14, opacity:1, text:"2019 value", stroke:"#003C57", x:13, y:-7},
{position:[xKey(120), 18], path:"M0 0 l0 10 l10 0", textAnchor:"start", fontSize: 14, opacity:1, text:"2020 value", stroke:"#00A3A6", x:13, y:13},
];

let keyTranslation;

if (width > 640 ) {keyTranslation = "translate(60,40)scale(1)" }
else if (width > 560) {keyTranslation = "translate(120,40)scale(1)"}
else if (width > 480) {keyTranslation = "translate(150,40)scale(0.9)"}
else if (width > 420) {keyTranslation = "translate(100,40)scale(0.95)"}
else {keyTranslation = "translate(100,40)scale(0.9)"}

	

</script>

{#if circleDataLower.length > 0 && circleDataHigher.length > 0}

<div class="funky"></div>

<h4 style="font-style: 18px">{area.name}'s lowest indicator score is for {circleDataLower[0]["label"].toLowerCase()} and its highest score is for {circleDataHigher[0]["label"].toLowerCase()}</h4>

<h5 style="font-style: 16px">Health index values for each indicator below 90 or above 110, {area.name}, 2020</h5>

<div class="chart-container">
	<svg style="display: block"
	{height}
	{width}
	>

	<g class="key"
	transform={keyTranslation}
	>

		<XAxis
		x={xKey}
		gridlinesParametersArray={gridlinesParametersArray.filter(function(e,i) {return e.value == 100})}
		y=20
		fontSize={"13px"}
		></XAxis>

		<g class="annotations">

			{#each annotationsArray as d, i}
				<Annotation
				id={i}
				position={d["position"]}
				path={d["path"]}
				textAnchor={d["textAnchor"]}
				fontSize={d["fontSize"]}
				opacity={d["opacity"]}
				text={d["text"]}
				stroke={d["stroke"]}
				x={d["x"]}
				y={d["y"]}
				></Annotation>
			{/each}
		</g>

		<g class="dot-plot-container"
		transform={"translate("+0+","+seriesPadding+")"}
		>	

			{#each [circleDataLower[0]] as d, i}

				<ViolinDotPlot
				key={true}
				{i}
				yPosition=8
				x={xKey}
				violinPlotData={distributionData.default.map(el=> {return {midpoint: el.midpoint, yValue: el[d["label"]]}})}
				violinFuncs={[pathCalcXKey, pathCalcInvXKey]}
				{seriesParametersArray}	
				circleData={[110,120]}
				radius={6}
				></ViolinDotPlot>
				
			{/each}
			
		</g>
	</g>

    <g class="titles"
	transform={"translate("+padding["left"]+",140)"}
	>

        <text
            stroke="none"
            fill="#333"
            font-size=16px
            text-anchor="start"
            font-weight="bold"
            >Indicators below 90</text>

        <text
			y={width > 560 ? 0: circleDataLower.length*60+80}
            x={width > 560 ? width/2 : 0}
            stroke="none"
            fill="#333"
            font-size=16px
            text-anchor="start"
            font-weight="bold"
            >Indicators above 110</text>

    </g>

	<g 
	class="chart-body"
	transform={"translate("+0+","+padding["top"]+")"}
	>

        <g transform={"translate("+padding["left"]+",0)"}>

            <XAxis
            {x}
            gridlinesParametersArray={width > 560 ? gridlinesParametersArray.filter(function(e,i) {return e.value <= 100}): gridlinesParametersArray}
            y={width > 560 ? (circleDataLower.length)*40+20: (circleDataLower.length)*60}
			fontSize={width > 560 ? "12px" : "13px"}
            ></XAxis>

        </g>

        <g transform={width > 560 ? "translate("+(padding["left"]+width/2)+",0)" : "translate("+(padding["left"])+","+(circleDataLower.length*60+95)+")"}>

            <XAxis
            {x}
            gridlinesParametersArray={width > 560 ? gridlinesParametersArray.filter(function(e,i) {return e.value >= 100}): gridlinesParametersArray }
            y={width > 560 ? (circleDataHigher.length)*40+20: (circleDataHigher.length)*60}
			fontSize={width > 560 ? "12px" : "13px"}
            ></XAxis>

        </g>

		<g class="dot-plot-container"
		transform={"translate("+padding["left"]+","+seriesPadding+")"}
		>	

			{#each circleDataLower as d, i}

				<ViolinDotPlot
				key={false}
				yPosition={y(i)+40}
				{x}
				violinPlotData={distributionData.default.map(el=> {return {midpoint: el.midpoint, yValue: el[d["label"]]}})}
				violinFuncs={[pathCalc, pathCalcInv]}
				{seriesParametersArray}	
				circleData={[d.value2019, d.value]}
				label={d["label"]}
                labelFontSize={width > 560 ? "12px" : "14px"}
                labelYValue={-12}
                backgroundToLabel={false}
				radius={width > 560 ? 6 : 7}
				hoverLabel={true}
				></ViolinDotPlot>
				
			{/each}
			
		</g>

        <g class="dot-plot-container"
		transform={width > 560 ? "translate("+(padding["left"]+width/2)+",0)" : "translate("+(padding["left"])+","+(circleDataLower.length*60+95)+")"}
		>	

			{#each circleDataHigher as d, i}

				<ViolinDotPlot
				key={false}
				yPosition={y(i)+40}
				{x}
				violinPlotData={distributionData.default.map(el=> {return {midpoint: el.midpoint, yValue: el[d["label"]]}})}
				violinFuncs={[pathCalc, pathCalcInv]}
				{seriesParametersArray}	
				circleData={[d.value2019, d.value]}
				label={d["label"]}
                labelYValue={-12}
                labelFontSize={width > 560 ? "12px" : "14px"}
                backgroundToLabel={false}
				radius={width > 560 ? 6 : 7}
				hoverLabel={true}
				></ViolinDotPlot>
				
			{/each}
			
		</g>
	
	</g>

	</svg>


<h6 style="display: block;">Source: Office for National Statistics – Health Index for England</h6>

<p style="display: block; line-height: 32px">Note: Scores of 90 and 110 are one standard deviation away from 100, the average score for England in 2015.</p>

</div>

{/if}







<style>
	.chart-container {
		width: 100%;
		height: 660px !important;
    	/* margin-left: auto; */
	}

</style>